import React from 'react';
import { useSelector } from 'react-redux';
import useTranslation from '@hooks/useTranslation';
import { selectRecipeDownloadDetails } from '../../features/interface/interfaceSlice';
import StreamOperationIndicator from '../streamOperationIndicator/streamOperationIndicator';
import { AsyncRequestStatus } from '../../types/core_t';

type MessageTypes = 'success' | 'progress' | 'error';

const RecipeDownloadIndicator = (): React.JSX.Element | null => {
	const t = useTranslation('DownloadRecipe');
	const asyncOperation = useSelector(selectRecipeDownloadDetails);
	const downloadStatus = asyncOperation?.status;
	let message = t('Progress');
	let messageType: MessageTypes = 'progress';

	if (downloadStatus === AsyncRequestStatus.completed) {
		messageType = 'success';
		message = t('Success');
	} else if (downloadStatus === AsyncRequestStatus.error) {
		messageType = 'error';
		message = t('Failure');
	}


	if (!downloadStatus) { return null; }
	const combinedPercentage = (asyncOperation?.contentProgress || 0) + (asyncOperation?.storageProgress || 0);
	return (
		<StreamOperationIndicator
			errorReason={asyncOperation?.error?.message}
			message={message}
			percent={asyncOperation?.noProgress ? undefined : Math.floor(combinedPercentage/2)}
			type={messageType}
		/>
	);
};

export default RecipeDownloadIndicator;
